import styled from 'styled-components';
import {media, tokens} from "../../../theme";

export const Message = styled.div`
    display: flex;
    position: relative;
    margin-bottom: 32px;

    &:last-child {
        margin-bottom: 16px;
    }
`;

interface MessageYouProps {
    $hasAttachment?: boolean;
}

export const MessageYou = styled(Message)<MessageYouProps>`
    position: relative;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.palette.message.userTextBg};
    height: fit-content;
    min-height: 44px;
    width: 100%;
    word-break: break-word;
    border-radius: ${tokens.radius.lg};
    margin-bottom: 0 !important;
    
    ${({ $hasAttachment: hasAttachment }) =>
    hasAttachment &&
    `
            border-bottom-left-radius: 0;
            border-bottom-right-radius: ${tokens.radius.lg};
        `
}
`;

export const MessageYouAuthor = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px;
    white-space: nowrap;
    
    border-radius: ${tokens.radius.md};
    font-weight: ${tokens.fontWeight.semibold};
    font-size: ${tokens.fontSize.sm};
    
    color: ${({ theme }) => theme.palette.text.primary};
    background: ${({ theme }) => theme.palette.message.userBg};
    z-index: 50;

    img {
        width: 30px;
        height: 30px;
        object-fit: cover;
    }

    span {
        padding-right: 8px;
    }

    ${media.sm} {
        gap: 10px;
        font-size: ${tokens.fontSize.base};

        img {
            width: 32px;
            height: 32px;
        }
    }

    ${media.md} {
        gap: 12px;

        img {
            width: 35px;
            height: 35px;
        }
    }
`;

export const MessageYouText = styled.div`
    height: fit-content;
    min-height: 44px;
    width: 100%;
    word-break: break-word;
    font-size: ${tokens.fontSize.sm};

    border-radius: 16px;
    padding: 8px 10px 8px 10px;
    display: flex;
    align-items: center;
    position: relative;

    &::before {
        content: '';
        background: ${({ theme }) => theme.palette.message.userTextBg};
        width: 40px;
        position: absolute;
    }

    img {
        width: 30px;
        height: 30px;
    }

    ${media.sm} {
        font-size: ${tokens.fontSize.base};


        img {
            width: 32px;
            height: 32px;
        }
    }

    ${media.md} {
        img {
            width: 35px;
            height: 35px;
        }
    }
`;

export const MessageSystemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const MessageSystemHeaderIcons = styled.div`
    display: flex;
    position: relative;
    bottom: 4px;
    gap: 4px;
    max-height: 36px;
`;

interface MessageSystemProps {
    $hasAttachment?: boolean;
}

export const MessageSystem = styled(Message)<MessageSystemProps>`
    flex-direction: column;
    align-items: flex-start;
    background: transparent;
    border-radius: ${tokens.radius.lg};
    padding: 12px;
    margin-bottom: 0 !important;
    
    ${({ $hasAttachment: hasAttachment }) =>
    hasAttachment &&
    `
        border-bottom-left-radius: 0;
        border-bottom-right-radius: ${tokens.radius.lg};
    `}

    ${media.sm} {
        padding: 14px;
    }

    ${media.md} {
        padding: 16px;
    }
`;

export const MessageSystemAuthor = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: ${tokens.radius.lg};
    
    padding: 12px;
    font-weight: ${tokens.fontWeight.semibold};
    font-size: ${tokens.fontSize.sm};
    background: ${({ theme }) => theme.palette.message.assistantTextBg};
    width: fit-content;
    margin-bottom: 8px;

    ${media.smPlus} {
        font-size: ${tokens.fontSize.base};
    }
`;


export const MessageSystemText = styled.div`
    font-weight: ${tokens.fontWeight.normal};
    font-size: ${tokens.fontSize.sm};
    word-break: break-word;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    gap: 8px;
    width: 100%;
    position: relative;
    color: ${({ theme }) => theme.palette.message.assistantText};
    background-color: transparent;

    ${media.smPlus} {
        font-size: ${tokens.fontSize.base};
    }
    
    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-x: auto;
    }

    pre code {
        display: block;
        max-width: 100%;
        box-sizing: border-box;
        white-space: inherit;
    }
`;

export const MessageTimestamp = styled.div`
    font-size: ${tokens.fontSize.sm};
    color: ${({ theme }) => theme.palette.text.hint};
    text-align: right;
    margin-top: 8px;
    margin-right: 8px;
    width: auto;
    position: relative;
    align-self: flex-start;

    ${media.sm} {
        font-size: ${tokens.fontSize.xs};
    }
`;

export const MessageAttachmentsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 32px;
`;


export const StyledButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: ${tokens.radius.lg};

    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    padding: 0;
    cursor: pointer;
    transition:
        background 0.2s ease,
        box-shadow 0.2s ease;
    font-size: ${tokens.fontSize.base};
    background: transparent;

    svg {
        width: 18px;
        height: 18px;
        min-width: 18px;
        min-height: 18px;
    }

    &:hover {
        background: ${({ theme }) => theme.palette.action.hover};
    }

    &:active {
        background: #d0d0d0;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }
`;